import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export type LotteryType = 'hk' | 'macau'
export type ApiRegion = 'hk' | 'aocai'

export const useRegionStore = defineStore('region-store', () => {
  const lotteryType = ref<LotteryType>('macau')

  // 映射到后端 API 的 region 参数值
  const region = computed<ApiRegion>(() => (lotteryType.value === 'hk' ? 'hk' : 'aocai'))

  function setLotteryType(type: LotteryType) {
    lotteryType.value = type
  }

  function setRegion(r: ApiRegion) {
    lotteryType.value = r === 'hk' ? 'hk' : 'macau'
  }

  return { lotteryType, region, setLotteryType, setRegion }
}, { persist: true })
